<template>
  <div class="p-the-page-m01 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />

        <div class="p-the-page-m01__inner">
          <CommonHeading class="p-the-page-m01__heading"
            >マイページ</CommonHeading
          >

          <div class="p-the-page-m01__card">
            <div class="p-the-page-m01__profile">
              <div
                class="p-the-page-m01__profile__header"
                :style="{ backgroundColor: colorCode }"
              ></div>
              <div class="p-the-page-m01__profile__detail">
                <div class="p-the-page-m01__profile__detail__icon">
                  <IconUserImage :size="profileIconSize">
                    <!-- #59042対応によりセッション情報からavatarを取得するように修正-->
                    <img :src="avatar" alt />
                  </IconUserImage>
                </div>
                <div class="p-the-page-m01__profile__detail__basis">
                  <p class="p-the-page-m01__profile__detail__name">
                    {{ userInfo.full_name }}
                  </p>

                  <div class="p-the-page-m01__profile__detail__data">
                    <dl class="p-the-page-m01__profile__detail__list">
                      <dt class="p-the-page-m01__profile__detail__term">
                        所属グループ：
                      </dt>
                      <dd class="p-the-page-m01__profile__detail__description">
                        {{ userInfo.group_name }}
                      </dd>
                    </dl>
                    <dl class="p-the-page-m01__profile__detail__list">
                      <dt class="p-the-page-m01__profile__detail__term">
                        サービス登録日：
                      </dt>
                      <dd class="p-the-page-m01__profile__detail__description">
                        {{ registrationDate }}
                      </dd>
                    </dl>
                  </div>
                </div>

                <ButtonMain
                  tag="a"
                  href="/profile-update/"
                  kind="secondary -border_none -background_none"
                  tabindex="0"
                  class="p-the-page-m01__profile__detail__button"
                  >編集する</ButtonMain
                >
              </div>
              <div class="p-the-page-m01__profile__comment">
                <IconBase
                  class="p-the-page-m01__profile__comment__icon"
                  view-box="0 0 29 29"
                  width="29"
                  height="29"
                >
                  <IconComment />
                </IconBase>
                <p class="p-the-page-m01__profile__comment__text">
                  {{ userInfo.bio ? userInfo.bio : "未登録" }}
                </p>
              </div>
            </div>
          </div>

          <div class="p-the-page-m01__subpanel">
            <div
              class="
                p-the-page-m01__subpanel__inner
                p-the-page-m01__subpanel__inner--point
              "
            >
              <h2 class="p-the-page-m01__subpanel__heading">ポイント情報</h2>
              <div class="p-the-page-m01__subpanel__card">
                <div class="p-the-page-m01__current_point">
                  <dl>
                    <dt class="p-the-page-m01__current_point__term">
                      総ポイント数
                    </dt>
                    <dd class="p-the-page-m01__current_point__description">
                      <PointNotation
                        :icon-size="32"
                        :icon-sp-size="24"
                        :point="points"
                        :unit="unit"
                        :font-size="currentPointFontSize"
                        :sign-is-exists="false"
                      />
                    </dd>
                  </dl>

                  <ButtonMain
                    tag="a"
                    :href="urlPointConfirmation + '?redirect_from=my-page'"
                    kind="secondary -border_none -background_none"
                    tabindex="0"
                    class="p-the-page-m01__subpanel__button"
                    >履歴を見る</ButtonMain
                  >
                </div>
                <div class="p-the-page-m01__point_condition">
                  <h3 class="p-the-page-m01__point_condition__heading">
                    付与基準
                  </h3>

                  <div class="p-the-page-m01__point_condition__data__wrap">
                    <dl
                      v-for="(condition, key) in conditions"
                      :key="key"
                      class="p-the-page-m01__point_condition__data"
                    >
                      <dt class="p-the-page-m01__point_condition__data__term">
                        <i
                          class="
                            p-the-page-m01__point_condition__data__term__icon
                          "
                        >
                          <IconInvestedRounded
                            :bg-color="colorCode"
                            icon-color="#ffffff"
                            :type="condition.icon_type"
                            :icon-size="36"
                          />
                        </i>
                        <span
                          class="
                            p-the-page-m01__point_condition__data__term__name
                          "
                          >{{ condition.name }}</span
                        >
                      </dt>
                      <dd
                        class="
                          p-the-page-m01__point_condition__data__description
                        "
                      >
                        <PointNotation
                          :point="condition.points"
                          :unit="unit"
                          :font-size="conditionPointFontSize"
                          :sign-is-exists="'plus'"
                        />
                      </dd>
                    </dl>
                  </div>

                  <ButtonMain
                    tag="a"
                    :href="urlGrantCriteria + '?redirect_from=my-page'"
                    kind="secondary -border_none -background_none"
                    tabindex="0"
                    class="p-the-page-m01__subpanel__button"
                    >もっと見る</ButtonMain
                  >
                </div>
              </div>
            </div>
            <div
              class="
                p-the-page-m01__subpanel__inner
                p-the-page-m01__subpanel__inner--account
              "
            >
              <h2 class="p-the-page-m01__subpanel__heading">アカウント情報</h2>
              <div class="p-the-page-m01__subpanel__card">
                <ul class="p-the-page-m01__list">
                  <li class="p-the-page-m01__list__item">
                    <span class="p-the-page-m01__account__id"
                      >ID：{{ userInfo.usingEmployeeId }}</span
                    >
                  </li>
                  <li class="p-the-page-m01__list__item">
                    <M01AccountAnchor href="/mail-delivery-settings/"
                      >メール受信設定</M01AccountAnchor
                    >
                  </li>
                  <li class="p-the-page-m01__list__item">
                    <M01AccountAnchor href="/my-page/email-settings/"
                      >メールアドレスの変更</M01AccountAnchor
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TheFooter />

    <ModalMain v-if="modalName === 'profile-update-complete'">
      <template #head>
        プロフィールの変更が
        <br />完了しました。
      </template>
      <template #body>
        <ButtonMain kind="cancel" @click-button="closeModal">OK</ButtonMain>
      </template>
    </ModalMain>

    <ModalMain v-if="modalName === 'personalInformationUpdated'">
      <template #head>個人情報の変更が完了しました。</template>
      <template #body>
        <ButtonMain kind="cancel" @click-button="closeModal">OK</ButtonMain>
      </template>
    </ModalMain>

    <ModalMain v-if="modalName === 'm06_complete'">
      <template #head>パスワードの変更が完了しました。</template>
      <template #body>
        <ButtonMain kind="cancel" @click-button="closeModal">OK</ButtonMain>
      </template>
    </ModalMain>

    <ModalMain v-if="modalName === 'secretQuestionUpdated'">
      <template #head>秘密の質問の変更が完了しました。</template>
      <template #body>
        <ButtonMain kind="cancel" @click-button="closeModal">OK</ButtonMain>
      </template>
    </ModalMain>
  </div>
</template>

<script lang="ts">
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconComment from "@/common/components/icons/IconComment.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import M01AccountAnchor from "@/general/components/pages/parts/MyPage//M01AccountAnchor.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Options, Vue } from "vue-class-component";
import modalState from "@/common/store/modules/modalState";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { getGrantCriteriaList, getUserProfile } from "@/general/store/api";
import { mapState } from "vuex";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { UserInfo } from "@/general/store/models";
import AuthStorage from "@/general/utils/auth";
import AuthApi from "@/general/api/authApi";
@Options({
  props: {
    modal: { type: String, default: "", required: false }
  },
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    ButtonMain,
    IconUserImage,
    IconBase,
    IconComment,
    IconInvestedRounded,
    PointNotation,
    M01AccountAnchor,
    ModalMain,
    TheBreadcrumb
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  },
  watch: {
    closeModalState() {
      modalState.changeModal("");
    }
  }
})
export default class MyPage extends Vue {
  modal!: string;
  points: any = 0;
  closeModalState = modalState.closeModalState;
  changeModal: any = "";
  organizationId!: string;
  currentPage!: number;
  userInfo: UserInfo = {} as UserInfo;
  id!: any;
  unit = commons.unit;
  conditions = commons.conditions;
  modalName = this.modal;
  avatar = "";

  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "マイページ",
      url: CONST_DATA.SITE_MAP.DEFAULT,
      pageType: "lower"
    }
  ];

  declare $refs: {
    theHeader: TheHeader;
  };

  get urlPointConfirmation() {
    return CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
  }

  get registrationDate() {
    if (this.userInfo && this.userInfo.application_start_date) {
      return this.$dayjs
        .utc(this.userInfo.application_start_date)
        .locale("ja")
        .format("YYYY/MM/DD");
    }
    return null;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  closeModal() {
    this.modalName = "";
  }
  get point() {
    return this.points;
  }
  get currentPointFontSize() {
    return this.isSp ? 28 : 32;
  }
  get conditionPointFontSize() {
    return this.isSp ? 14 : 24;
  }
  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 96;
  }

  get urlGrantCriteria() {
    return CONST_DATA.SITE_MAP.GRANT_CRITERIA;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const organizationParam = commons.Orgspecific?.id;

    this.organizationId = organizationParam;
    this.id = 0;

    const userProfile = await getUserProfile("");
    this.points = userProfile.data.total_points;
    this.userInfo = auth.user;

    const grantCriteriaList = await getGrantCriteriaList(
      "",
      this.currentPage,
      4,
      ""
    );
    this.conditions = grantCriteriaList.results;
    await commons.getBreadcrumb(this.breadcrumb);

    if (this.modal) {
      this.changeModal(this.modal);
    }

    //#59042対応によりセッション情報からavatarを取得するように修正
    await AuthApi.getICSession()
      .then((result) => {
        const ic_session = JSON.parse(result);
        this.avatar = ic_session.avatar;
      })
      .catch(() => {
        this.avatar = "";
      });
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-m01 {
  background-color: $common-bg;

  &__inner {
    padding-top: rem(48);
    padding-bottom: rem(80);

    @include sp {
      padding-top: rem(32);
      padding-bottom: rem(40);
    }
  }

  &__heading {
    @include sp {
      font-size: rem(20);
      line-height: (27/20);
    }
  }

  &__card {
    margin-top: rem(32);
    border-radius: px(4);
    background-color: $common-white;

    @include sp {
      margin-top: rem(20);
    }
  }

  &__profile {
    &__header {
      @include pc {
        display: none;
      }
      @include sp {
        height: rem(56);
      }
    }
    &__detail {
      position: relative;
      padding: rem(40) rem(32) rem(24) rem(32);
      display: flex;

      @include sp {
        padding: rem(16) rem(16) rem(28) rem(16);
        display: block;
      }

      &__icon {
        border-radius: 50%;
        overflow: hidden;
        background-color: white;

        @include pc {
          width: rem(96);
          height: rem(96);
          margin-right: rem(32);
          margin-top: rem(-8);
        }
        @include sp {
          width: rem(80);
          height: rem(80);
          margin-top: rem(-52);
        }

        &__img {
          width: 100%;
          display: block;
        }
      }

      &__basis {
        @include pc {
          flex: 1;
        }
        @include sp {
          margin-top: rem(24);
        }
      }

      &__name {
        font-size: rem(16);
        font-weight: bold;
        line-height: (22/16);
      }

      &__data {
        margin-top: rem(24);
      }
      &__list {
        margin-top: rem(4);
        display: flex;
      }

      &__term {
        font-size: rem(14);

        @include sp {
          font-size: rem(12);
        }
      }
      &__description {
        font-size: rem(14);

        @include sp {
          font-size: rem(12);
        }
      }

      &__button {
        position: absolute;
        z-index: 30;

        @include pc {
          right: rem(24);
          top: rem(32);
        }
        @include sp {
          right: rem(0);
          top: rem(12);
        }
      }
    }
    &__comment {
      padding: rem(30) rem(32) rem(32) rem(32);
      border: px(1) solid $common-gray100;
      display: flex;

      @include sp {
        padding: rem(18) rem(16);
        display: block;
      }

      &__icon {
        color: $common-gray500;
        width: rem(29);

        @include pc {
          margin-right: rem(16);
        }
      }
      &__text {
        font-size: rem(14);
        line-height: 19px;
        flex: 1;
        align-self: center;

        @include sp {
          margin-top: rem(8);
        }
      }
    }
  }

  &__subpanel {
    margin-top: rem(24);
    display: flex;

    @include large-sp {
      display: block;
    }

    &__inner {
      &--point {
        width: 40%;
        min-width: rem(320);
        margin-right: rem(24);

        @include large-sp {
          width: 100%;
          min-width: auto;
          margin-right: auto;
        }
      }
      &--account {
        flex: 1;
      }
      & + & {
        @include large-sp {
          margin-top: rem(24);
        }
      }
    }

    &__card {
      margin-top: rem(16);
      border-radius: px(4);
      background-color: $common-white;
    }

    &__heading {
      color: $common-black-sub;
      font-size: rem(16);
      font-weight: bold;
    }

    &__button {
      position: absolute;
      right: rem(0);
      top: rem(8);
    }
  }

  &__current_point {
    position: relative;
    padding: rem(18) rem(16) rem(14) rem(16);

    &__term {
      font-size: rem(20);
      font-weight: bold;
      line-height: (27/20);

      @include sp {
        font-size: rem(12);
        line-height: (16/12);
      }
    }
    &__description {
      margin-top: rem(8);
    }
  }
  &__point_condition {
    position: relative;
    padding: rem(18) rem(16) rem(19) rem(16);
    border-top: px(1) solid $common-gray-border;

    &__heading {
      color: $common-black-sub;
      font-weight: bold;
      font-size: rem(16);
      line-height: (22/16);

      @include sp {
        font-size: rem(12);
        line-height: (16/12);
      }
    }

    &__data {
      margin-top: rem(12);
      display: flex;
      align-items: center;

      &:first-child {
        margin-top: rem(0);
      }

      &__wrap {
        margin-top: rem(20);
      }

      &__term {
        display: flex;
        align-items: center;

        &__icon {
          line-height: 1;
        }

        &__name {
          font-size: rem(14);
          margin-left: rem(12);
        }
      }
      &__description {
        margin-right: 0;
        margin-left: auto;
      }
    }
  }

  &__list {
    &__item {
      border-top: px(1) solid $common-gray-border;

      &:first-child {
        border-top: none;
      }
      &:last-child {
        padding-bottom: rem(2);
      }
    }
  }

  &__account {
    &__id {
      font-size: rem(14);
      padding: rem(18) rem(16) rem(19) rem(16);
      display: block;
    }
  }
}
</style>
